const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export const apiUrl = (path) => `${API}${path}`;
export const img = (file, w = 960) => `${API}/img/${w}/${file}`;
export const srcSet = (file, lowRes = false) =>
  lowRes ? `${img(file, 480)} 480w` : `${img(file, 480)} 480w, ${img(file, 960)} 960w, ${img(file, 1600)} 1600w`;
export const altOf = (p, lang) => (lang === "es" ? p?.alt_es : p?.alt) || p?.alt || "";
export const nameOf = (t, lang) => (lang === "es" ? t?.name_es : t?.name) || t?.name || "";
